<template>
	<InventarisationPageTemplate
		v-slot="{ selectedCustomerId, selectedIndex, customers }"
	>
		<ExtractionSuggestionBanner
			v-if="
				extractionEnabled && identitySuggestions(selectedCustomerId).length > 0
			"
			:suggestions="identitySuggestions(selectedCustomerId)"
			@dismiss="extractionSuggestions.dismiss"
			@open="openSuggestion($event, selectedCustomerId)"
		/>

		<ExtractionSuggestionBanner
			v-if="extractionEnabled && unmatchedIdentity.length > 0"
			:suggestions="unmatchedIdentity"
			label="Geëxtraheerde persoonsgegevens beschikbaar"
			variant="warning"
			@dismiss="extractionSuggestions.dismiss"
			@open="openSuggestion($event, null)"
		/>

		<ExtractionApplyModal
			v-if="selectedSuggestion"
			:suggestion="selectedSuggestion"
			:dossier-id="dossierStore.selectedDossier?.id ?? ''"
			:customer-id="modalCustomerId"
			:version-data="dossierDataStore.data as Record<string, unknown> | null"
			:customers="customers"
			@close="selectedSuggestion = undefined"
			@mark-bekeken="extractionSuggestions.markBekeken"
		/>

		<InventarisationCustomerForm
			v-if="customers[selectedIndex]"
			:key="selectedCustomerId"
			v-model="customers[selectedIndex]"
			:customers="customers"
		/>
	</InventarisationPageTemplate>
</template>

<script lang="ts" setup>
import { computed, ref } from "vue";
import { useFeatureFlag } from "@/composables/useFeatureFlag";
import {
	useExtractionSuggestions,
	type ExtractionSuggestion,
} from "@/composables/useExtractionSuggestions";
import { useDossierStore } from "@/store/useDossierStore";
import { useDossierDataStore } from "@/store/useDossierDataStore";
import ExtractionSuggestionBanner from "@/components/inventarisation/ExtractionSuggestionBanner.vue";
import ExtractionApplyModal from "@/components/inventarisation/ExtractionApplyModal.vue";

const dossierStore = useDossierStore();
const dossierDataStore = useDossierDataStore();
const extractionEnabled = useFeatureFlag("document-extraction-intermediary");

const extractionSuggestions = useExtractionSuggestions(
	() => dossierStore.selectedDossier?.id,
);

function identitySuggestions(customerId: string | undefined) {
	return extractionSuggestions.forCustomerAndSection(customerId, "identity")
		.value;
}

const unmatchedIdentity = computed(
	() => extractionSuggestions.unmatchedForSection("identity").value,
);

const selectedSuggestion = ref<ExtractionSuggestion>();
const modalCustomerId = ref<string | null>(null);

function openSuggestion(
	suggestion: ExtractionSuggestion,
	customerId: string | undefined | null,
) {
	selectedSuggestion.value = suggestion;
	modalCustomerId.value = customerId ?? null;
}
</script>
